export default __webpack_public_path__ + "static/RobotoMono-Medium-3b2846cd0d0707c04811d38f300fd730.ttf";